import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { TermoUsoPaVirtualProps } from '../../../interfaces/props/SaudeOnline/PAVirtual/TermoUsoPaVirtualProps';
import { aceitaTermoResponsabilidade, retornaTermoPaVirtual } from '../../../services/SaudeOnlineService';
import './styles.css';
import { sxButton, sxCheckbox } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function TermoDeUsoPaVirtual(props: TermoUsoPaVirtualProps) {

  const [readed, setReaded] = useState<boolean>(false);
  const [agreed, setAgreed] = useState<boolean>(false);
  const [terms, setTerms] = useState<string>('');
  const [termsId, setTermsId] = useState<string>('');
  const { backStep, handleTermsOfUse } = { ...props };

  const { fontSizeStyleAccessibility } = useAccessibility();

  useEffect(() => {
    const getTerms = async () => {
      const result = await retornaTermoPaVirtual();
      setTerms(result.descricao);
      setTermsId(result.idTermoResponsabilidade);
    }

    getTerms();
  }, []);

  const handleScroll = (event: React.UIEvent<HTMLElement>) => {
    const target = event.target as HTMLElement;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      setReaded(true)
    }
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAgreed(event.target.checked);
  };

  const acceptTermsOfUse = async () => {
    const result = await aceitaTermoResponsabilidade(termsId, 'S');
    if (result?.status === 200) {
      handleTermsOfUse();
    }
  }

  return (
    <div className="terms-of-use-holder">
      <div className="terms-description-holder">
        <div className="terms-description" onScroll={handleScroll}>
          {parse(terms)}
        </div>
      </div>
      <div className="terms-checkbox">
        <FormControlLabel disabled={!readed} control={<Checkbox onChange={handleCheck} />} label="Eu li e concordo com os termos" sx={sxCheckbox} />
      </div>
      <div className="hours-buttons">
        <Button
          variant="contained"
          size="large"
          onClick={acceptTermsOfUse}
          style={fontSizeStyleAccessibility}
          sx={sxButton}
          disabled={!agreed}
          fullWidth>
          PROSSEGUIR
        </Button>
      </div>
      <button className="back-button" onClick={backStep}>
        <FontAwesomeIcon icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
      </button>
    </div>
  )
}

export default TermoDeUsoPaVirtual;